import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import Button from "theme/components/atoms/Button";
import SubNavigation from "../SubNavigation";
import CategoriesMenu from "./CategoriesMenu";

const MainCategoryElement = ({ category, selectCategory, renderSubNav }) => {
  return (
    <>
      {category.children.length === 0 ? (
        <Link to={category.path}>{category.name}</Link>
      ) : (
        <Button
          appearance="link"
          onClick={() => {
            selectCategory();
          }}
        >
          {category.name}
        </Button>
      )}
      {renderSubNav(
        <SubNavigation onClose={() => selectCategory(null)}>
          <CategoriesMenu category={category} />
        </SubNavigation>
      )}
    </>
  );
};

const MenuMainCategories = ({ data, selectMenu, renderSubNav }) => {
  return data.navigationMenu && data.navigationMenu.length ? (
    <nav className="menu-main-categories">
      <ul className="menu-main-categories__list">
        {data.navigationMenu.map((category) => (
          <li className="menu-main-categories__item" key={category.id}>
            <MainCategoryElement
              category={category}
              selectCategory={() => selectMenu(`category_${category.id}`)}
              renderSubNav={renderSubNav(`category_${category.id}`)}
            />
          </li>
        ))}
      </ul>
    </nav>
  ) : null;
};

export default MenuMainCategories;
